import { OccConfig, OccEndpoint } from '@spartacus/core';

declare module '@spartacus/core' {
  interface OccEndpoints {
    verifyUser?: string | OccEndpoint;
    sendVerifyOtp?: string | OccEndpoint;
  }
}
export const rrsOccUserProfileConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        userRegister: 'users',
        userForgotPassword: 'forgottenpasswordtokens',
        userResetPassword: 'resetpassword',
        userUpdateLoginId: 'users/${userId}/login',
        userUpdatePassword: 'users/${userId}/password',
        titles: 'titles',
        verifyUser: 'verify',
        sendVerifyOtp: 'users/${userId}/verify',
      },
    },
  },
};
